import React, { createContext, useContext, useEffect, useState } from 'react'
import * as Location from 'expo-location'
import { PostsServices } from '../../../../database/posts.database'
// Amplify v6: no usar Auth global aquí; si se necesita token, usar fetchAuthSession en servicios.
import { Alert, Linking } from 'react-native'

const LocationStatePro = createContext()

export const LocationState = ({ children }) => {
    const [userLat, setUserLat] = useState(0)
    const [userLng, setUserLng] = useState(0)
    const [errorMsg, setErrorMsg] = useState(null)
    const [locationLoaded, setLocationLoaded] = useState(false)
    const [lastUpdateCoorsUser, setLastUpdateCoorsUser] = useState(null)

    const updateLocation = async () => {
        try {
            let { status } = await Location.getForegroundPermissionsAsync()
            if (status !== 'granted') {
                // askAgain()
                setErrorMsg('Permission to access location was denied')
                // console.error('Permission to access location was denied')
                return
            }
            // traigo primero de base local
            const userLocation = await PostsServices.getLocationUser()

            if (userLocation && userLocation.lat && userLocation.lng) {
                setUserLat(userLocation.lat)
                setUserLng(userLocation.lng)
                setLastUpdateCoorsUser(new Date(userLocation.last_update_coords))
            }

            // Intentar obtener la ubicación actual
            let location = await Location.getCurrentPositionAsync({
                accuracy: Location.Accuracy.Highest,
                maximumAge: 10000,
                timeout: 5000,
            })

            const { latitude, longitude } = location.coords
            setUserLat(latitude)
            setUserLng(longitude)
            // const session = await Auth.currentAuthenticatedUser({ bypassCache: true }).catch((err) => {
            //     console.log('Error al obtener el usuario autenticado en location', err)
            //     return null
            // })
            if (latitude && longitude) {
                let currentDate = new Date()
                setLastUpdateCoorsUser(currentDate)
                await PostsServices.updateUserLocation(latitude, longitude, currentDate)
                // await PostsServices.getUser().then((user) => {
                //     console.log('11111111111 desde el context este es el user', user);
                // })
            }
            return { lat: latitude, lng: longitude, lastUpdateCoorsUser }
        } catch (error) {
            console.log('🚀 ~ updateLocation ~ error:', error)
            console.error('func. locationContex', error)
            setErrorMsg('Error getting current location, trying last known position')

            try {
                // Intentar obtener la última ubicación conocida
                // console.log('Intentar obtener la última ubicación conocida')
                // const session = await Auth.currentAuthenticatedUser({ bypassCache: true }).catch((err) => {
                //     console.log('Error al obtener el usuario autenticado en location', err)
                //     return null
                // })
                // if (session) {
                let location = await Location.getLastKnownPositionAsync({
                    accuracy: Location.Accuracy.Highest,
                })
                if (location) {
                    const { latitude, longitude } = location.coords
                    setUserLat(latitude)
                    setUserLng(longitude)

                    let currentDate = new Date()
                    setLastUpdateCoorsUser(currentDate)

                    if (latitude && longitude) {
                        await PostsServices.updateUserLocation(latitude, longitude, currentDate)
                    }
                    return { lat: latitude, lng: longitude }
                } else {
                    throw new Error('No last known position available')
                }
                // }
            } catch (error) {
                // Capturar error si la obtención de la última ubicación conocida falla
                console.error('Error getting last known location:', error)
                setErrorMsg('Error getting last known location')
            }
        }
    }
    const requestPermissions = async () => {
        try {
            let { status } = await Location.requestForegroundPermissionsAsync()
            if (status !== 'granted') {
                askAgain()
                console.error('Permission to access location was denied')
                return
            }
        } catch (error) {
            console.error('Error requesting location permissions:', error)
            //setErrorMsg('Error requesting location permissions')
        }
    }

    // const checkLocation = async () => {
    //     const locationInterval = setInterval(() => {
    //         // updateLocation().then((location) => {
    //         //     return location
    //         // })
    //     }, 10000)
    //     return () => clearInterval(locationInterval)
    // }
    const checkLocation = async () => {
        //
        // const locationInterval = setInterval(() => {
        //     ; (async () => {
        try {
            // await askAgain()
            console.log('====================================')
            console.log('check location')
            console.log('====================================')
            const location = await updateLocation()
            // const session = await Auth.currentAuthenticatedUser({ bypassCache: true })
            // if (session) {

            //     console.log('🚀 ~ //; ~ location:', location)
            // } else {
            //     console.log('No tengo user, por lo q no pido ubi')
            // }
        } catch (error) {
            console.error('location', error)
            setLocationLoaded(true)
        } finally {
            setLocationLoaded(true)
        }
        //     })()
        // }, 10000)

        // return () => clearInterval(locationInterval)
    }

    const askAgain = async () => {
        try {
            const permission = await Location.getForegroundPermissionsAsync()
            if (!permission.canAskAgain || permission.status === 'denied') {
                Alert.alert(
                    'Permisos de localización',
                    'La App requiere conocer tu ubicación para poder brindarte información de tiendas.',
                    [
                        {
                            text: 'Cancelar',
                            onPress: async () => {},
                        },
                        {
                            text: 'Configuración',
                            onPress: async () => {
                                Linking.openSettings()
                            },
                        },
                    ],
                    { cancelable: true },
                )
            }
        } catch (error) {
            console.error('🚀 ~ askAgain ~ error:', error)
        }
    }

    useEffect(() => {
        checkLocation()
    }, [])

    const value = {
        userLat,
        userLng,
        setUserLat,
        setUserLng,
        updateLocation,
        errorMsg,
        requestPermissions,
        checkLocation,
        askAgain,
        lastUpdateCoorsUser,
        locationLoaded,
    }

    return <LocationStatePro.Provider value={value}>{children}</LocationStatePro.Provider>
}

export const getLocation = () => {
    return useContext(LocationStatePro)
}
